import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
// import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from '../../../../Config';
import { getSpecializationList } from '../../../../Redux/action/MasterAction';
import { useDispatch } from 'react-redux';
const EditMaster = ({ show, handleClose, onSuccess, SpecializationId, SpecializationName }) => {
    const token = Cookies.get('token');
    let user_id = Cookies.get('flexichain_user_id');
    const dispatch = useDispatch()
    const validationSchema = Yup.object({
        name: Yup.string().required('Specialization Name is required'),

        // name: Yup.string().required('Code is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            name: '', // Initial value for the RequiredService type

        },
        validationSchema: validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            handleClose()

            setSubmitting(true);
            try {
                
                const response = await fetch(`${adminMainUrl}/api/transport/master/specialization/update?id=${SpecializationId}`, {
                    method: 'POST',
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': user_id,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(values),
                });

                const data = await response.json();

                if (response.ok) {
                    // closeButtonRef.current.click();
                    if (onSuccess) onSuccess();
                    toast.success(data?.msg);
                    handleClose()
                    dispatch(getSpecializationList(token, user_id));
                } else {
                    toast.error(data?.msg);
                    // Handle errors from the server
                    console.error('Error creating RequiredService Type:', data.message);
                }
            } catch (error) {
                console.error('Network error:', error);
            }
            finally {
                setSubmitting(false); // Stop the spinner
            }
        },
    });
    useEffect(() => {
        if (SpecializationName) {
            formik.setFieldValue("name", SpecializationName);
        }
    }, [SpecializationName])
    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Add Specialization</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-12">

                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Specialization Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="name"
                                    name="name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                />
                                {formik.touched.name && formik.errors.name ? (
                                    <div className="error">{formik.errors.name}</div>
                                ) : null}
                            </div>
                        </div>

                    </div>
                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary text-xs" type="submit" disabled={formik.isSubmitting}>
                            {formik.isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button>
                        {/* <button className="btn btn-primary text-xs" type="submit" >
                            Submit
                        </button> */}
                    </div>

                </form>
                </Offcanvas.Body>
        </Offcanvas>
    )
}

export default EditMaster